export const URL_HOME = '/survey_results'
export const URL_RESULTS_VIEW = '/survey_results_view'